<template>
    <div class="main-wrapper">

		<div class="login-page">
			<div class="login-body container">
				<div class="loginbox">
					<div class="login-right-wrap">
						<div class="account-header">
							<div class="account-logo text-center mb-4">
								<router-link to="/">
                  <a href="/" class="text-lg" style="font-size: 26px">
                    <span 
                      class="font-weight-600 text-slate-300" 
                      :style="logoPrefixStyle"
                    >
                      {{ branding.logo.prefix }}
                    </span>
                    <span 
                      class="font-weight-bold text-slate-500"
                      :style="logoSuffixStyle"
                    >
                      {{ branding.logo.suffix }}
                    </span>
                  </a>
                </router-link>
							</div>
						</div>
						<div class="login-header text-center">
							<h6 class="text-muted" style="color: darkgreen">Resend verification code</h6>
              <div class="mt-4">
                <div v-if="success === true && message" class="alert alert-success alert-dismissible fade show" role="alert">
                  <strong>Success!</strong> {{ message }}
                  <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="resetMessage">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div v-if="success === false && message" class="alert alert-danger alert-dismissible fade show" role="alert">
                  {{ message }}
                  <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="resetMessage">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
              </div>
						</div>

						<form action="">
							<div class="form-group mb-4">
                <input
                  type="email"
                  class="form-control"
                  id="token"
                  required
                  v-model="email"
                  name="email"
                  placeholder="Enter your email"
                />
							</div>
              <div class="text-center">
                <button 
                  class="btn btn-primary btn-block account-btn" 
                  type="button" 
                  @click="resendVerificationCode()"
                  :style="{ 
                    backgroundColor: branding.buttonColor, 
                    color: branding.buttonTextColor, 
                    borderColor: branding.buttonColor 
                  }"
                >
                  Resend verification
                </button>
              </div>
						</form>
              <div class="login-or">
                <span class="or-line"></span>
                <span class="span-or">or</span>
              </div>
            <div class="text-center dont-have">
              Already registered? 
              <router-link 
                to="/login"
                :style="{ color: branding.primaryColor, fontWeight: '600' }"
              > 
                Login
              </router-link>
            </div>
            <div class="text-center dont-have">
              <div>
                <small id="terms-footnote" class="footnote">
                  {{ branding.footerText }} 
                  <a 
                    :href="branding.privacyPolicyUrl" 
                    target="_blank" 
                    :style="{ color: branding.primaryColor }"
                  >
                    privacy policy
                  </a> 
                  and 
                  <a 
                    :href="branding.termsUrl" 
                    target="_blank" 
                    :style="{ color: branding.primaryColor }"
                  >
                    terms and conditions
                  </a> 
                  that govern your usage of our services.
                </small>
              </div>
            </div>
          </div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import authServiceApi from "../../service/AuthServiceApi.js"
import {errorCodes} from "../../interceptors/codes";
import { getBrandingByDomain } from "@/config/domainBranding";

export default {
  name: "Resend-verification-user",
  data() {
    return {
      success: null,
      message: "",
      token: undefined,
      email: undefined,
      branding: getBrandingByDomain(location.host)
    };
  },
  computed: {
    logoSuffixStyle() {
      return {
        color: this.branding.logo.suffixColor || '#ffffff',
        fontWeight: 'bold',
        backgroundColor: this.branding.logo.suffixBackgroundColor || this.branding.primaryColor,
        padding: '6px',
        borderRadius: '5px'
      }
    },
    logoPrefixStyle() {
      return {
        color: this.branding.logo.prefixColor || this.branding.secondaryColor
      }
    }
  },
  methods: {
    login(){
      this.$router.push('/login');
    },
    resendVerificationCode() {
      let loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel,
      });
      let data = {
        email: this.email,
        domain: location.host
      }
      authServiceApi.resendVerificationCode(data)
        .then(response => {
          let success = response.data.success;
          if (success){
            this.success = true
            this.message = response.data.narrative
            this.resetMessage()
            this.$router.push("/register/confirm")
          } else {
            this.success = false
            this.message = response.data.narrative
          }
        })
        .catch(e => {
          console.log("Error: ", e)
          const code = e.response.status;
          const error = errorCodes[code];
          this.success = false
          this.message = code === 400 ? (e.response.data.description || e.response.data.narrative) : error.description
        }).finally(() => {
        loader.hide()
      })
    },
    resetMessage(){
      this.message = ""
    },
  },
  mounted() {
    this.token = this.$route.query.token;
    if (this.token){
      this.verifyAccount()
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/auth/ResendCode.vue